import TabsAndSearch from './TabsAndSearch'

export default TabsAndSearch
